import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import { RODEO_PAGE_NAME } from "src/_config";
import { APPLICATION_NAME } from "src/_config";
import RodeoEventGroupPage from "src/components/events/rodeoEventGroup/rodeoEventGroupPage";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import LandingPage from "src/components/landing/landingPage";

export default function RodeoEventGroupContainer() {
  const gameDetails = useAppGameDetailsSelector();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Event Groups`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      {gameDetails?.is_show_landing_page == 1 ? (
        <>
          <Sidebar page={RODEO_PAGE_NAME.LANDING} />
          <LandingPage />
        </>
      ) : (
        <>
          <Sidebar page={RODEO_PAGE_NAME.EVENT_GROUP} />
          <RodeoEventGroupPage />
        </>
      )}
      {/* <Sidebar page={RODEO_PAGE_NAME.EVENT_GROUP} />
      {gameDetails?.is_show_landing_page == 1 ? <LandingPage /> : <RodeoEventGroupPage />} */}
    </React.Fragment>
  );
}
